import type { Season, SeasonDeep, SeasonTree } from '@protector/entities/season/models';
import type { Dictionary, Moment, UUID } from '@protector/utils/types';
import axios from 'axios-observable';
import type { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { CORE_SERVICES_API_URL, PROTECTOR_API_URL } from 'config/constants';
import moment from 'moment';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const coreServicesApiUrl = CORE_SERVICES_API_URL;
const protectorApiUrl = PROTECTOR_API_URL;
const seasonDeepUrl = (id: string) => `${coreServicesApiUrl}/v1/seasons/${id}/deep`;

export const getSeasonDeep = (idSeason: UUID): Observable<SeasonDeep> => {
  return axios.get<SeasonDeep>(seasonDeepUrl(idSeason)).pipe(map(response => response.data));
};

export const getSelectedSeasonsPeriod = (selectedSeasons: string[], seasonEntites: Dictionary<Season>) => {
  const seasons = selectedSeasons.map(seasonId => seasonEntites[seasonId]);
  let minDate: Moment = moment();
  let maxDate: Moment = moment();
  seasons.forEach(season => {
    if (minDate === undefined || moment(season.start_date).isBefore(minDate)) {
      minDate = moment(season.start_date);
    }
    if (maxDate === undefined || moment(season.end_date).isAfter(maxDate)) {
      maxDate = moment(season.end_date);
    }
  });

  return { minDate, maxDate };
};

export const getSeasonsTreeByCompany = (companyId: UUID): AxiosObservable<SeasonTree[]> => {
  return axios.get<SeasonTree[]>(`${protectorApiUrl}/v1/companies/${companyId}/seasons/tree`);
};
